//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from "@/utils"
import api from "@/api"
export default {
    name: 'HeaderView',
    props:['headerActive','WorkName'],
    data () {
        return {
            collapse:false,

            Word:'',
            activeIndex:'',
            dialogVisible: false,
            activeStr:'UserCenter',
           
        }
    },
    created(){
       
    },
    methods:{
         back (str) {
            this.$confirm('您确定退出吗？')
            .then(_ => {
                this.axios.post(api.LoginOut).then((res)=>{
                    window.localStorage.clear()
                    this.$router.push({name: 'login'})
                })
            })
        },
        LinkUrl (str) {
            this.$router.push({name: str})
        },
       
      
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/HeaderView.vue